import { generateActionType } from '../utils/utilFunctions'

export const ADMIN_GET_ALL_USER = generateActionType('ADMIN_GET_ALL_USER')
export const ADMIN_GET_ALL_USER_APPLY = generateActionType('ADMIN_GET_ALL_USER_APPLY')
export const ADMIN_GET_USER_AGENDA = generateActionType('ADMIN_GET_USER_AGENDA')
export const ADMIN_GET_AGENDA_COUNSELLOR = generateActionType('ADMIN_GET_AGENDA_COUNSELLOR')
export const ADMIN_GET_USER_DIARY = generateActionType('ADMIN_GET_USER_DIARY')
export const ADMIN_GET_USER_PRACTICE = generateActionType('ADMIN_GET_USER_PRACTICE')
export const ADMIN_GET_USER_DETAIL = generateActionType('ADMIN_GET_USER_DETAIL')
export const ADMIN_GET_ROOMS= generateActionType('ADMIN_GET_ROOMS')
export const ADMIN_GET_USER_PROFILE = generateActionType('ADMIN_GET_USER_PROFILE')
